<template>
    <div class="cost-config-container">
        <el-form ref="costForm" :model="costForm" label-width="200px" class="cost-form">
            <el-card class="config-card">
                <template #header>
                    <div class="card-header">
                        <span class="card-title">成本配置</span>
                    </div>
                </template>

                <el-form-item label="蒸馏成本价（点数）">
                    <el-input-number v-model="costForm.distillation_num" :min="0" :step="0.01" :precision="2" />
                    <div class="help-text">设置AI关键词蒸馏服务的成本价格</div>
                </el-form-item>

                <el-form-item label="AI创作成本价（点数）">
                    <el-input-number v-model="costForm.cx_num" :min="0" :step="0.01" :precision="2" />
                    <div class="help-text">设置AI创作服务的成本价格</div>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="submitCostConfig" :loading="submitting">保存配置</el-button>
                    <el-button @click="resetForm">重置</el-button>
                </el-form-item>
            </el-card>
        </el-form>
    </div>
</template>

<script>
import axios from 'axios'
import config from '@/config.js'
import Cookies from 'js-cookie'

export default {
    name: 'CostConfig',
    data() {
        return {
            costForm: {
                distillation_num: 0.00,
                cx_num: 0.00
            },
            submitting: false
        }
    },
    computed: {
        userInfo() {
            return JSON.parse(Cookies.get('user_info') || '{}')
        }
    },
    mounted() {
        this.fetchCostConfig()
    },
    methods: {
        // 获取成本配置
        async fetchCostConfig() {
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    {
                        action: 'get_cost_config',
                        store_id: this.userInfo.id
                    }
                )

                if (data.success && data.data) {
                    this.costForm = {
                        distillation_num: parseFloat(data.data.distillation_num) || 0.00,
                        cx_num: parseFloat(data.data.cx_num) || 0.00
                    }
                }
            } catch (error) {
                this.$message.error('获取成本配置失败')
                console.error('获取成本配置错误:', error)
            }
        },

        // 提交成本配置
        async submitCostConfig() {
            this.submitting = true
            try {
                const { data } = await axios.post(
                    `${config.BASE_URL}/site/api/system_config.php`,
                    {
                        action: 'update_cost_config',
                        store_id: this.userInfo.id,
                        ...this.costForm
                    }
                )

                if (data.success) {
                    this.$message.success('成本配置更新成功')
                } else {
                    this.$message.error(data.error || '更新失败')
                }
            } catch (error) {
                const errorMsg = error.response?.data?.error || error.message || '更新失败'
                this.$message.error(`更新失败: ${errorMsg}`)
                console.error('成本配置更新错误:', error)
            } finally {
                this.submitting = false
            }
        },

        // 重置表单
        resetForm() {
            this.fetchCostConfig()
        }
    }
}
</script>

<style scoped lang="scss">
.cost-config-container {
    padding: 0px;
}

.config-card {
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 112, 72, 0.3);

    :deep(.el-card__header) {
        background: rgba(255, 112, 72, 0.1);
        border-bottom: 1px solid rgba(255, 112, 72, 0.2);
    }

    .card-header {
        .card-title {
            color: #ff7048;
            font-weight: 600;
            font-size: 16px;
        }
    }
}

.help-text {
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
}

:deep(.el-form-item__label) {
    color: #e0e6ff !important;
    font-weight: 500;
}

:deep(.el-input-number) {
    width: 200px;
}

:deep(.el-input-number .el-input__inner) {
    color: #ffffff !important;
    border: 1px solid rgba(255, 112, 72, 0.3) !important;
}
</style>